import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table/table.component';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgDragDropModule } from 'ng-drag-drop';

@NgModule({
  declarations: [TableComponent],
  imports: [
    CommonModule,
    FilterPipeModule,
    FormsModule,
    ScrollingModule,
    AngularMultiSelectModule,
    NgbModule,
    SharedModule,
    NgSelectModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgDragDropModule.forRoot()
  ],
  exports: [TableComponent]
})
export class TableModule { }
